import { TabGroup, Typography } from 'procyon-ui'
import React from 'react'
import { Active } from './components/tabs'
import { AllIntegration } from './components/tabs'

const Integrations = () => {
  return (
    <div>
      <div>
        <Typography variant='h3'>Integrations</Typography>
      </div>

      <div className='bg-[var(--color-common-bg-base)] p-5 mt-8 h-screen'>
        <TabGroup
          onChangeTab={function noRefCheck() {}}
          tabs={[
            {
              label: 'Active',
              tabContent: <Active />
            },
            {
              label: 'All Integrations',
              tabContent: <AllIntegration />
            }
          ]}
        />
      </div>
    </div>
  )
}

export { Integrations }
